export default {
    CONNECT_DEVICE: 'GET_DEVICE_CONNECTED',
    CHANGE_DEVICE_COLOR: 'ADJUST_DEVICE_COLOR',
    READ_ARTICLE_1: 'READ_ARTICLE_1',
    READ_ARTICLE_2: 'READ_ARTICLE_2',
    ADD_APP_TO_HOME_SCREEN: 'APP_ON_THE_HOMESCREEN',
    EXPLORE_USAGE_INSIGHT: 'EXPLORE_USAGE_INSIGHTS',
    IQOS_CLUB_VIDEO: 'IQOS_CLUB_VIDEO',
    IQOS_EXPERT_VIDEO: 'IQOS_EXPERT_VIDEO',
    QUEST_CHAMPION_VIDEO: 'QUEST_CHAMPION_VIDEO',
    QUEST_CHAMPION_QUIZ: 'QUEST_CHAMPION_QUIZ',
    IQOS_EXPERT_QUIZ: 'IQOS_EXPERT_QUIZ',
    DO_PUZZLE: 'DO_PUZZLE',
    SWITCH_11: 'SWITCH_11',
    SWITCH_12: 'SWITCH_12',
    SWITCH_13: 'SWITCH_13',
    SWITCH_14: 'SWITCH_14',
    SWITCH_15: 'SWITCH_15',
    SWITCH_21: 'SWITCH_21',
    SWITCH_22: 'SWITCH_22',
    SWITCH_23: 'SWITCH_23',
    SWITCH_24: 'SWITCH_24',
    SWITCH_25: 'SWITCH_25',
    SWITCH_31: 'SWITCH_31',
    SWITCH_32: 'SWITCH_32',
    SWITCH_33: 'SWITCH_33',
    SWITCH_34: 'SWITCH_34',
    SWITCH_35: 'SWITCH_35',
};
